import * as types from './constants';

// Remove Batch Message Template
export const removeBatchMessageTemplateRequest = data => (
  { type: types.REMOVE_BATCH_MESSAGE_TEMPLATE_REQUEST, payload: data }
);

export const removeBatchMessageTemplateDone = data => (
  { type: types.REMOVE_BATCH_MESSAGE_TEMPLATE_DONE, payload: data }
);

export const removeBatchMessageTemplateFailed = errors => (
  { type: types.REMOVE_BATCH_MESSAGE_TEMPLATE_FAILED, payload: errors }
);